import { useDispatch } from 'react-redux';
import { Asset } from '../../../api';
import { ALLOWED_EXTENSIONS } from '../model';
import * as searchActions from '../actions';

export const useSimilarButton = (
  asset: Asset | undefined,
): { isVisible: boolean; onClick?: () => void } => {
  const dispatch = useDispatch();

  if (asset?.preview && ALLOWED_EXTENSIONS.includes(asset.preview.extension)) {
    return {
      isVisible: true,
      onClick: () =>
        dispatch(
          searchActions.similarAssetChanged({
            similarAsset: { id: asset.id, name: asset.name },
          }),
        ),
    };
  }

  return { isVisible: false, onClick: undefined };
};
